export default __webpack_public_path__ + "static/media/icecream22.62692d98.svg";